import React from 'react'
import { Button, Container, Row, Card, Col } from 'react-bootstrap';
import { NavLink } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faCheck } from '@fortawesome/free-brands-svg-icons'
import styles from './QISoftware.module.scss';
const SASQIDesc = () => {
    return (<>

<Container className='outerContainer'>
            <h1 className="mb-4 centerText">SAS QI Software</h1>
            <p className="lead centerText">Harnessing the power of SAS/STAT software for advanced users</p>
        </Container>
        <div className={styles.downloadBox}>
            <Container className="outerContainer">
                <h3>SAS QI v2021 Full Software Package</h3>
                <p>The QI/STAT modules are programs that run in the SAS statistical software package. To use these modules, users must have access to SAS, which may be purchased from The SAS Institute.</p>
                <p className="mb-1">Software improvements include:</p>
                <ul>
                    <li>Enhancements to select indicators.</li>
                    <li>Revised program and file names for enhanced usability.</li>
                    <li>Application files now organized into separate folders for user Program, Macros, and Parameter Files.</li>
                </ul>
                <p className="mb-1 danger">Note:</p>
                <ul>
                    <li>To learn what changed in v2021 <a href="https://www.qualityindicators.ahrq.gov/Downloads/Software/SAS/V2021/AHRQ_SASQI_v2021_Software_Rel_Notes.pdf">click here.</a></li>
                    <li>To see frequently asked questions, <a href="https://www.qualityindicators.ahrq.gov/News/ICD10_v2021_FAQ.pdf">click here</a> to access v2021 software release FAQ document.</li>
                </ul>
                <Button href="https://www.qualityindicators.ahrq.gov/Downloads/Software/SAS/V2021/SAS_V2021_ICD-10-CM-PCS_QI_Software.zip">Download</Button>
            </Container>
        </div>
    </>)
}

export default SASQIDesc;